import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import OrderManagementPage from "./pages/OrderManagementPage";
import MessageManagementPage from "./pages/MessageManagementPage";
import ProductManagementPage from "./pages/ProductManagementPage";
import BundledProductManagementPage from "./pages/BundledProductPage";
import PrintifyProductsPage from "./pages/PrintifyProductsPage";
import TeeLaunchProductsPage from "./pages/TeeLaunchProductsPage";
import CategoryManagementPage from "./pages/CategoryManagementPage";
import ProdigiProductPage from "./pages/ProdigiProductsPage";
import HolidayPage from "./pages/HolidayPage";
import PromotionsPage from "./pages/PromotionManagementPage";
import LuluBookManagementPage from "./pages/LuluBookManagementPage";
import AddToCardDataPage from "./pages/AddToCartDataPage";
import CallbackManagementPage from "./pages/CallbackManagementPage";
import React from "react";
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import {PrivateRoute} from "./components/PrivateRoute";

function App() {

    return (
        <Router>
            <Header/>
            <Routes>
                <Route path="/login" element={<LoginPage/>}/>
                <Route element={<PrivateRoute/>}>
                    <Route path="/" element={<HomePage/>}/>
                    <Route path="/ordermanagement" element={<OrderManagementPage/>}/>
                    <Route path="/messagemanagement" element={<MessageManagementPage/>}/>
                    <Route path="/productmanagement" element={<ProductManagementPage/>}/>
                    <Route path="/bundledproductmanagment" element={<BundledProductManagementPage/>}/>
                    <Route path="/printifyproducts" element={<PrintifyProductsPage/>}/>
                    <Route path="/teelaunchproducts" element={<TeeLaunchProductsPage/>}/>
                    <Route path="/categorymanagement" element={<CategoryManagementPage/>}/>
                    <Route path="/prodigiproducts" element={<ProdigiProductPage/>}/>
                    <Route path="/holidays" element={<HolidayPage/>}/>
                    <Route path="/promotions" element={<PromotionsPage/>}/>
                    <Route path="/lulu-book-management" element={<LuluBookManagementPage/>}/>
                    <Route path="/add-to-cart-data" element={<AddToCardDataPage/>}/>
                    <Route path="/callback-data" element={<CallbackManagementPage/>}/>
                </Route>
            </Routes>

            <Footer className="bg-primary text-white relative z-30"/>
        </Router>
    );
}

export default App;
